import React, { useState, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import MDButton from "components/MDButton";
import { useNavigate } from "react-router-dom";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import EmptyDatesView from "../dates/EmptyDatesView";
import AddDateView from "../dates/AddDateView";
import DatesListView from "../dates/DatesListView";
import SelectionService from "../../../services/SelectionService";
import StepperNav from "../StepperNav";
import axios from "axios";
import config from "../../../config";
import { useLocation } from "react-router-dom";

const API_TOKEN = config.MAP_MATCHING_API_TOKEN;
const API_URL = config.MAP_MATCHING_API_URL;
function Dates() {
  const [view, setView] = useState("empty"); // empty, add, list
  const [dates, setDates] = useState([]);
  const [selectedDateIndex, setSelectedDateIndex] = useState(null); // Tracks selected date
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false); 
  const location = useLocation();
  const userId= location.state?.userId;
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Start loading
      try {
        console.log("Fetching data for userId:", userId); // Log the userId being used
        const response = await axios.get(`${API_URL}/report_dates/user/${userId}`, {
          headers: {
            "X-API-Key": API_TOKEN,
          },
        });
        console.log("Fetched data:", response.data); // Log the fetched data
        if (response.data.length > 0) {
          setDates(response.data);
          SelectionService.setDates(response.data);
          if (view === "empty") setView("list");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }finally {
        setLoading(false); // Stop loading
      }
    };

    fetchData();
    const savedIndex = SelectionService.getSelectedDate();
    if (savedIndex !== null) setSelectedDateIndex(savedIndex);
  }, []);

  const handleAddDate = (value) => {
    console.log(`Button clicked with value: ${value}`); // Log the value passed from EmptyDatesView
    setView("add"); // Use the passed value to update the view
  };

  const transformDateObject = (input) => ({
    name: input.title,
    from: input.startDate[0],
    to: input.endDate[0],
    userId: userId
  });
  const handleSaveDate = async (newDate) => {
    if (!newDate) {
      setView(dates.length > 0 ? "list" : "empty");
      return;
    }
  
    try {
      console.log("Saving new date:", newDate); 
      const formattedDate = transformDateObject(newDate);
  
      const response = await axios.post(`${API_URL}/report_dates`, formattedDate, {
        headers: {
          "X-API-Key": API_TOKEN,
          "accept": "*/*",
          "Content-Type": "application/json"
        }
      });
      console.log("Response from server:", response.data); // Log the response from the server
      const updatedDates = [...dates, response.data];
      setDates(updatedDates);
      SelectionService.setDates(updatedDates);
      setView("list");
  
    } catch (error) {
      console.error("Error saving date:", error);
    }
  };


  const handleDeleteDate = async (index) => {
    const dateToDelete = SelectionService.getDates()[index];
    console.log("date to delete", dateToDelete);
  
    try {
      const response = await axios.delete(`${API_URL}/report_dates/${dateToDelete.id}`, {
        headers: {
          "X-API-Key": API_TOKEN,
          "accept": "*/*",
          "Content-Type": "application/json"
        }
      });
  
      
      SelectionService.deleteDate(index);
      SelectionService.resetSelectedIndex(index);
      setSelectedDateIndex(SelectionService.getSelectedDate());
      const updatedDates = SelectionService.getDates();
      setDates(updatedDates);
      setView("list");
  
      if (updatedDates.length === 0) {
        setView("empty");
      }
  
    } catch (error) {
      console.error("Error deleting date:", error);
    }
  };

  const handleSelectDate = (index) => {
    console.log("Selected date index:", index); // Log the selected date index
    setSelectedDateIndex(index); // Sets the selected date
    SelectionService.setSelectedDate(index);
  };

  const handleProceedToNextStep = () => {
    navigate("/trajectories/times", { state: { userId: userId } }); // Navigate to the next step
  };

  return (
    <DashboardLayout>
      <Grid container direction="row" sx={{ alignItems: "stretch", height: "87vh" }}>
        <Box sx={{ width: "30%", height: "87vh", display: "flex", flexDirection: "column" }}>
          <Grid container direction="column" sx={{ flex: 1 }} >
          <Grid item xs={8} sx={{ flexGrow: 1 }}>
            {view === "empty" && <EmptyDatesView OnAddDate={handleAddDate} />}
            {view === "add" && <AddDateView onSave={handleSaveDate} />}
            {view === "list" && (
              <DatesListView
                dates={dates}
                selectedDateIndex={selectedDateIndex}
                onDelete={handleDeleteDate}
                onSelect={handleSelectDate}
                OnAddDate={handleAddDate}
              />
            )}
           </Grid>
           <Grid item 
            xs="auto"
            sx={{
            mt: "auto", // Pushes the grid to the bottom of the container
            textAlign: "right", // Aligns buttons to the right
            }}>
         <Grid container justifyContent="flex-end" spacing={2}>
         <Grid item>
              <MDButton
                variant="contained"
                color="info"
                size="medium"
                disabled={selectedDateIndex === null}
                onClick={handleProceedToNextStep}>
                Next
              </MDButton>
              </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ flex: 1 }}>
          <StepperNav />
        </Box>
      </Grid>
    </DashboardLayout>
  );
}

export default Dates;
